/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_legal_link__cookies = /** @type {(inputs: {}) => string} */ () => {
	return `Cookies`
};

const en_legal_link__cookies = /** @type {(inputs: {}) => string} */ () => {
	return `Cookies`
};

const es_legal_link__cookies = /** @type {(inputs: {}) => string} */ () => {
	return `Cookies`
};

const fr_legal_link__cookies = /** @type {(inputs: {}) => string} */ () => {
	return `Cookies`
};

const it_legal_link__cookies = /** @type {(inputs: {}) => string} */ () => {
	return `Cookie`
};

const nl_legal_link__cookies = /** @type {(inputs: {}) => string} */ () => {
	return `Cookies`
};

const pt_legal_link__cookies = /** @type {(inputs: {}) => string} */ () => {
	return `Cookies`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const legal_link__cookies = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.legal_link__cookies(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("legal_link__cookies", locale)
	if (locale === "de") return de_legal_link__cookies(inputs)
	if (locale === "en") return en_legal_link__cookies(inputs)
	if (locale === "es") return es_legal_link__cookies(inputs)
	if (locale === "fr") return fr_legal_link__cookies(inputs)
	if (locale === "it") return it_legal_link__cookies(inputs)
	if (locale === "nl") return nl_legal_link__cookies(inputs)
	return pt_legal_link__cookies(inputs)
};